import React from 'react';
import { connect } from 'react-redux';
import {
	IonList,
	IonButton,
	IonRadioGroup,
	IonItem,
	IonLabel,
	IonRadio,
	IonSelect,
	IonSelectOption,
} from '@ionic/react';
import Layout from '../../components/layout';
import { withTranslation } from '../../lib/translate';
import {
	getIkentooMenu,
	getIkentooMenusForLocation,
	loading,
	setCommonModal,
	setDeliveryOption,
} from '../../store/actions';
import { checkBackgroundColor, forwardTo, getLocale, isDefined, isPromise } from '../../lib/utils';
import { getConfig } from '../../appConfig';
import Basket from '../../lib/basket';
import api from '../../lib/api';
import { Spacer, Subtitle, Title } from '../../components/common';
import './index.css';
import NoData from '../../components/noData';
import Loading from '../../components/spinner';
import { ReactComponent as TableIcon } from '../../assets/images/utensils.svg';
import { ReactComponent as CollectionIcon } from '../../assets/images/takeaway.svg';
import Modal from '../../components/modal';
import Flag from 'react-world-flags';


class DeliveryOptionsKiosk extends React.Component {
	state = {
		option: null,
		languageModalOpen: false,
		updated: false,
	};


	setDeliveryOption = async (option) => {
		const { kioskData } = this.props;

		localStorage.setItem('showApplyLoyaltyModal', true)
		if (Basket.has_multi_basket) {
			Basket.reset();
			Basket.setCollectionTime(null)

			Basket.setASAP(true)
			this.props.dispatch(setDeliveryOption(option));
			Basket.setDeliveryOption(option);
			Basket.setOrderType(option.id);
			forwardTo(option.route, { isLogoClicked: false });
		} else {

			const resturantId = kioskData?.kiosk_restaurant_id
				? kioskData.kiosk_restaurant_id
				: getConfig()?.kiosk
					? getConfig().kiosk.restaurant_id
					: null;
			const choosenRestaurant = this.props.restaurants.find(
				(restaurant) => restaurant.id === resturantId,
			);
			this.setState({ selectedRestaurant: choosenRestaurant });
			this.props.dispatch(setDeliveryOption(option));
			this.selectRestaurant(parseInt(resturantId), option.id);
			Basket.setASAP(true)

			this.props.dispatch(
				getIkentooMenusForLocation(choosenRestaurant.business_location_id, {
					pickTime: 'asap',
					json_time_selector:
						option.id == 'kiosk-collection'
							? choosenRestaurant.kiosk_json_time_selector
							: choosenRestaurant.kiosk_table_json_time_selector,
				}),
			);
		}

	};

	selectRestaurant = (resturantId, orderType) => {
		const { restaurants, profile, kioskData } = this.props;
		const tableNumber =
			kioskData && kioskData.kiosk_table_number && kioskData.kiosk_table_number !== '-1'
				? kioskData.kiosk_table_number
				: null;
		Basket.reset(profile.cardToken);
		Basket.setRestaurant(restaurants.find((restaurant) => restaurant.id === resturantId));
		Basket.setServicePercentage(0);
		Basket.setCollectionTime(null);
		Basket.setOrderType(orderType);
		if (orderType === 'kiosk-table') Basket.setTableNumber(tableNumber);
	};

	checkForSingleDeliveryOption = () => {
		const kioskDeliveryOptions = getConfig().kiosk.delivery.filter((el) => !el.isRemoved);
		const singleDeliveryOption =
			kioskDeliveryOptions.length === 1 ? kioskDeliveryOptions[0] : false;
		if (singleDeliveryOption && !isPromise(singleDeliveryOption))
			this.setDeliveryOption(singleDeliveryOption);
	};


	componentDidMount() {
		const { defaultMenuId } = this.props;
		this.props.dispatch(loading(true));
		Basket.reset();
		this.checkForSingleDeliveryOption();

		api.getDefaultMenu(defaultMenuId).then((res) => {
			this.props.dispatch({
				type: 'SET_RESTAURANT_PROP',
				key: 'defaultMenu',
				value: { ...res, menuName: `${res.menuName} Default` },
				merge: true,
			});
		});
		this.props.dispatch(loading(false));
	}
	changeIkentooMenus = (event) =>
		this.setState({ selectedIkentooMenu: event.detail.value, error: '' }, () => {
			Basket.setMenu(event.detail.value);
		});
	continueOnMenu = () => {
		const { restaurants, dispatch } = this.props;
		const { selectedIkentooMenu, selectedRestaurant } = this.state;
		if (selectedRestaurant && selectedIkentooMenu) {
			const choosenRestaurant = restaurants.find(
				(restaurant) => restaurant.id === selectedRestaurant.id,
			);
			const businessLocationId = choosenRestaurant.business_location_id;
			dispatch(getIkentooMenu(selectedIkentooMenu, businessLocationId));
		} else {
			this.setState({ error: 'Please select location menu' });
		}
	};

	formatDataForSelect = (langs) => {
		const { __ } = this.props;
		let arrForSelect = [];
		Object.keys(langs).forEach((key) => {
			arrForSelect.push({ text: __(langs[key]), value: key });
		});
		return [...arrForSelect];
	};
	handleLanguageInput = (data) => {
		localStorage.setItem('locale', data)
		getLocale()
		this.setState({ updated: !this.state.updated }, () => {
			setTimeout(() => {
				this.setState({ languageModalOpen: false, })
			}, 0);
		})

	};
	render() {
		const { __, isChooseMenuModalOpen, clientProfile, clientStyles } = this.props;
		const { selectedIkentooMenu, languageModalOpen } = this.state;
		const config = getConfig();
		const kioskConfig = isDefined(config.kiosk)
			? config.kiosk
			: {
				table: true,
				collection: true,
			};
		const menus = this.props.ikentooMenusForLocation;
		const animationMenuClass = isChooseMenuModalOpen ? 'show-up' : '';
		const collectionData = kioskConfig.delivery.filter(el => !el.isRemoved && !el.isDisabled && el.id == 'kiosk-collection')
		const tableData = kioskConfig.delivery.filter(el => !el.isRemoved && !el.isDisabled && el.id == 'kiosk-table')
		const languages = Object.keys(getConfig().localization.supportedLocales);
		const locale = getLocale()
		const formatedLocales = this.formatDataForSelect(getConfig().localization.supportedLocales)
		let logoColor = 'dark'

		if (clientStyles.colors?.['--okx-background-color']) {
			logoColor = checkBackgroundColor(clientStyles.colors?.['--okx-background-color'])
		}
		return (
			<Loading>
				<Layout blank scrollY={false} color="transparent">
					<div className='absolute-content medium-padding scrollable-y delivery-options-wrapper grid-wrapper grid-justify-center text-centered'>
						<div className='grid-wrapper grid-justify-center'>

							<img className='large-logo block' src={logoColor == 'dark' ? clientProfile.logo_image : clientProfile.logo_image_light} />
							<Spacer size={5} />
							<Title>{__('Where will you be eating to day?')}</Title>
							<Spacer size={4} />

							<div className='order-type-wrapper'>
								{tableData.length > 0 &&
									<div onClick={() => this.setDeliveryOption(tableData[0])}>
										<TableIcon />
										<Subtitle>{__('Eat in')}</Subtitle>
									</div>
								}
								{collectionData.length > 0 &&
									<div onClick={() => this.setDeliveryOption(collectionData[0])}>
										<CollectionIcon />
										<Subtitle>{__('Take away')}</Subtitle>
									</div>
								}
							</div>
						</div>
						{languages.length <= 1 ? null : (
							<div style={{ flex: 1, display: 'flex', alignItems: 'flex-end' }}>
								<div style={{ display: 'flex', alignItems: 'center', gap: '20px' }} className='language-selector' onClick={() => this.setState({ languageModalOpen: true })}>
									<Flag width='56px' height='56px' code={locale == 'en' ? 'gb' : locale} />
									<Subtitle>{__(getConfig().localization.supportedLocales[locale])}</Subtitle>
								</div>
								<Modal className='modal-type-alert'
									onDidDismiss={() => {
										this.setState({ languageModalOpen: false })
									}}
									isOpen={languageModalOpen}>
									<Spacer size={5} />
									<div style={{ display: 'grid', gap: '40px' }} >
										{formatedLocales.map(el => (
											<div style={{ display: 'flex', alignItems: 'center', gap: '20px' }} onClick={() => {
												this.handleLanguageInput(el.value)
											}}>
												<Flag width='56px' height='56px' code={el.value == 'en' ? 'gb' : el.value} />
												<Subtitle value={el.value}>{__(el.text)}</Subtitle>
											</div>
										))}
									</div>

									<Spacer size={3} />
								</Modal>
								{/* <Spacer size={3} />
								<IonItem className='input-field-wrapper input-field-wrapper-large' lines='none'>
									<IonSelect onIonChange={(e) => localStorage.setItem('locale', e.detail.value)} value={locale} aria-label="language" interface="action-sheet" placeholder="Select fruit">
										{formatedLocales.map(el => (
											<IonSelectOption value={el.value}>{__(el.text)}</IonSelectOption>

										))}

									</IonSelect>
								</IonItem> */}

							</div>

						)}

					</div>

					{!menus.length ? null : (
						<>
							<div
								className="click-collect-pickers-backdrop"
								style={{ display: isChooseMenuModalOpen ? '' : 'none' }}
								onClick={() => this.props.dispatch(setCommonModal('isChooseMenuModalOpen', false))}
							></div>

							<div className={`click-collect-dialog ${animationMenuClass} kiosk-menu-dialog`}>
								<div className="click-collect-dialog-layout sc-ion-modal-md">
									<div className="click-collect-dialog-header">
										<Title>{__('Choose menu')}</Title>
									</div>
									<div
										className="click-collect-dialog-closer"
										onClick={() =>
											this.props.dispatch(setCommonModal('isChooseMenuModalOpen', false))
										}
									>
										<ion-icon
											name="close"
											role="img"
											class="md hydrated"
											aria-label="close"
										></ion-icon>
									</div>
									<div className="click-collect-dialog-content">
										<IonList lines="none">
											<IonRadioGroup
												onIonChange={this.changeIkentooMenus}
												value={selectedIkentooMenu}
											>
												{!menus.length ? (
													<NoData />
												) : (
													menus.map((menu) => {
														const { ikentooMenuId, menuName } = menu;
														return (
															<IonItem
																style={{ marginBottom: '10px' }}
																className="box-wrapper"
																key={ikentooMenuId}
																lines="none"
															>
																<div tabIndex="-1"></div>
																<IonLabel className="ion-text-wrap">
																	<Subtitle>{menuName}</Subtitle>
																</IonLabel>
																<IonRadio color="primary" slot="start" value={ikentooMenuId} />
															</IonItem>
														);
													})
												)}
											</IonRadioGroup>
										</IonList>
									</div>
									<div className="click-collect-dialog-action">
										<IonButton
											disabled={menus.length > 0 ? false : true}
											expand="block"
											color="primary"
											className="customized-button"
											onClick={() => this.continueOnMenu()}
										>
											{__('Continue')}
										</IonButton>
									</div>
								</div>
							</div>
						</>
					)}
				</Layout>
			</Loading>
		);
	}
}

const stateToProps = (state) => {
	const { restaurants, ikentooMenu, ikentooMenusForLocation } = state.restaurants;
	const { isChooseMenuModalOpen, clientProfile, clientStyles } = state.common;
	const { kioskData } = state.profile;
	return {
		restaurants: restaurants || [],
		profile: state.profile.profile,
		deliveryOption: state.orders.deliveryOption,
		defaultMenuId: state.common.defaultMenuId,
		kioskData: kioskData,
		ikentooMenu: ikentooMenu || {},
		ikentooMenusForLocation: ikentooMenusForLocation || [],
		isChooseMenuModalOpen,
		clientProfile,
		clientStyles
	};
};
export default connect(stateToProps)(withTranslation(DeliveryOptionsKiosk));
